export const SP_VOTE_COLLECTION_SIGN= 'super-puper-collection';export const SP_VOTE_COLLECTION_SIGN= 'super-puper-collection';